<div class="cdp-corridor-mapping-container">
    <div class="spinner-container" *ngIf="spinnerBoolean">
      <div class="spinner"></div>
      <div class="spinner-text">Loading CDP corridor mappings...</div>
    </div>

    <ng-container *ngIf="!spinnerBoolean">
    <!-- Title bar with centered title and action buttons -->
    <div class="table-actions-bar">
      <div class="table-title">CDP Corridor Mapping</div>
      <div class="button-group">
        <button (click)="clearSelection()" [disabled]="!canClearSelection()">
          Clear Selection
        </button>
        <button (click)="clearAllFilters()" [disabled]="!hasActiveFilters()">
          Clear All Filters
        </button>
        <button (click)="cancelEdit()" *ngIf="hasEditingRows()">Cancel</button>
        <button (click)="addNewRow()">New</button>
        <button (click)="saveRows()" [disabled]="!cdpMappings.length">
          Save
        </button>
        <button (click)="openExportDialog()" [disabled]="!cdpMappings.length">
          Export
        </button>
        <button
          (click)="deleteSelectedMappings()"
          [disabled]="!selectedRows.length"
        >
          Delete
        </button>
      </div>
    </div>
  
    <div class="table-container">
      <div class="table-header-container">
        <div class="table-header-row">
          <div class="table-header-cell fixed-width-cell-select">Select</div>
          <div class="table-header-cell">
            <div class="col-wrap">
              <div class="text-wrap">Development Area</div>
              <div
                style="
                  width: 20%;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
              >
                <img
                  class="filter-icon"
                  [ngClass]="{ 'active-filter': isFilterActive('developmentArea') }"
                  [src]="isFilterActive('developmentArea') ? '../../assets/img/filtered.png' : '../../assets/img/Filter.png'"
                  width="16"
                  height="16"
                  alt="Filter"
                  (click)="openFloatingFilter($event, 'developmentArea')"
                  [title]="isFilterActive('developmentArea') ? 'Filter applied - Development Area' : 'Filter Development Area'"
                />
              </div>
            </div>
          </div>
          <div class="table-header-cell">
            <div class="col-wrap">
              <div class="text-wrap">Facility Type</div>
              <div
                style="
                  width: 20%;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
              >
                <img
                  class="filter-icon"
                  [ngClass]="{ 'active-filter': isFilterActive('facilityType') }"
                  [src]="isFilterActive('facilityType') ? '../../assets/img/filtered.png' : '../../assets/img/Filter.png'"
                  width="16"
                  height="16"
                  alt="Filter"
                  (click)="openFloatingFilter($event, 'facilityType')"
                  [title]="isFilterActive('facilityType') ? 'Filter applied - Facility Type' : 'Filter Facility Type'"
                />
              </div>
            </div>
          </div>
          <div class="table-header-cell">
            <div class="col-wrap">
              <div class="text-wrap">CDPs to Group</div>
              <div
                style="
                  width: 20%;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
              >
                <img
                  class="filter-icon"
                  [ngClass]="{ 'active-filter': isFilterActive('cdpsToGroup') }"
                  [src]="isFilterActive('cdpsToGroup') ? '../../assets/img/filtered.png' : '../../assets/img/Filter.png'"
                  width="16"
                  height="16"
                  alt="Filter"
                  (click)="openFloatingFilter($event, 'cdpsToGroup')"
                  [title]="isFilterActive('cdpsToGroup') ? 'Filter applied - CDPs to Group' : 'Filter CDPs to Group'"
                />
              </div>
            </div>
          </div>
          <div class="table-header-cell">
            <div class="col-wrap">
              <div class="text-wrap">Combined CDP Facility Name</div>
              <div
                style="
                  width: 20%;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
              >
                <img
                  class="filter-icon"
                  [ngClass]="{ 'active-filter': isFilterActive('connectedCdpNetworkName') }"
                  [src]="isFilterActive('connectedCdpNetworkName') ? '../../assets/img/filtered.png' : '../../assets/img/Filter.png'"
                  width="16"
                  height="16"
                  alt="Filter"
                  (click)="openFloatingFilter($event, 'connectedCdpNetworkName')"
                  [title]="isFilterActive('connectedCdpNetworkName') ? 'Filter applied - Connected CDP Network Name' : 'Filter Connected CDP Network Name'"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <div class="table-body-container">
        <div
          class="table-body-row"
          *ngFor="let mapping of filteredCdpMappings; let i = index"
        >
          <!-- Select Checkbox -->
          <div class="table-body-cell fixed-width-cell-select">
            <input
              type="checkbox"
              [checked]="selectedRows.includes(mapping)"
              (change)="toggleRowSelection(mapping, $event)"
            />
          </div>
  
          <!-- Development Area Dropdown -->
          <div class="table-body-cell">
            <div class="cell-wrapper">
              <ng-container *ngIf="mapping.isNew; else readOnlyDevelopmentArea">
                <select
                  [(ngModel)]="mapping.developmentArea"
                  class="form-select"
                  (focus)="markAsEdited(mapping)"
                  (change)="onDevelopmentAreaChange(mapping)"
                >
                  <option value="">Select Development Area</option>
                  <option *ngFor="let area of developmentAreas" [value]="area">
                    {{ area }}
                  </option>
                </select>
              </ng-container>
              <ng-template #readOnlyDevelopmentArea>
                <div class="readonly-cell-value">
                  {{ mapping.developmentArea || '-' }}
                </div>
              </ng-template>
            </div>
          </div>

          <!-- Facility Type Dropdown -->
          <div class="table-body-cell">
            <div class="cell-wrapper">
              <ng-container *ngIf="mapping.isNew; else readOnlyFacilityType">
                <select
                  [(ngModel)]="mapping.facilityType"
                  class="form-select"
                  (focus)="markAsEdited(mapping)"
                  (change)="markAsEdited(mapping)"
                >
                  <option value="">Select Facility Type</option>
                  <option *ngFor="let type of facilityTypes" [value]="type">
                    {{ type }}
                  </option>
                </select>
              </ng-container>
              <ng-template #readOnlyFacilityType>
                <div class="readonly-cell-value">
                  {{ mapping.facilityType || '-' }}
                </div>
              </ng-template>
            </div>
          </div>
  
          <!-- CDPs to Group Multi-Select -->
          <div class="table-body-cell">
            <div class="multi-facility-field">
              <div class="facility-tags">
                <span
                  *ngFor="let cdp of mapping.cdpsToGroup"
                  class="facility-chip"
                >
                  {{ cdp }}
                  <span
                    class="remove-chip"
                    (click)="removeCdp(mapping, cdp)"
                    >×</span
                  >
                </span>
                <select
                  class="facility-select"
                  (focus)="markAsEdited(mapping)"
                  (change)="addCdp(mapping, $event)"
                  [disabled]="!mapping.developmentArea"
                >
                  <option value="" disabled selected hidden>
                    {{
                      !mapping.developmentArea
                        ? "Select Dev Area first"
                        : "Select CDP"
                    }}
                  </option>
                  <option
                    *ngFor="
                      let cdp of getCdpsForDevArea(mapping.developmentArea)
                    "
                    [value]="cdp"
                    [disabled]="mapping.cdpsToGroup.includes(cdp)"
                  >
                    {{ cdp }}
                  </option>
                </select>
              </div>
              <!-- <div *ngIf="mapping.cdpsToGroup.length < 2 && mapping.isEditing" 
                   class="validation-error">
                At least 2 CDPs must be selected
              </div> -->
            </div>
          </div>
  
          <!-- Connected CDP Network Name - Auto-populated but editable -->
          <div class="table-body-cell">
            <div class="cell-wrapper">
              <input
                type="text"
                [(ngModel)]="mapping.connectedCdpNetworkName"
                class="form-input"
                (focus)="markAsEdited(mapping)"
                (change)="markAsEdited(mapping)"
                placeholder="Auto-filled from selected CDPs"
                title="Auto-populated from selected CDPs: {{
                  mapping.cdpsToGroup.join(', ')
                }}"
                style="width: 100%; min-width: 250px"
              />
            </div>
          </div>
        </div>
  
        <!-- Empty state -->
        <div *ngIf="!spinnerBoolean && filteredCdpMappings.length === 0" class="empty-state">
          No CDP corridor mappings available. Click "New" to get started.
        </div>
      </div>
    </div>
    </ng-container>
  </div>
  
  <!-- Floating Filter Box -->
  <div
    class="floating-filter-dropdown"
    *ngIf="showFloatingFilter"
    [ngStyle]="{
      top: dropdownPosition.top + 'px',
      left: dropdownPosition.left + 'px'
    }"
  >
    <input
      type="text"
      [(ngModel)]="filterSearch[activeFilter]"
      placeholder="Search..."
    />
    <div class="filter-options">
      <label *ngFor="let option of getFilterOptions(activeFilter)">
        <input
          type="checkbox"
          [checked]="isChecked(activeFilter, option)"
          (change)="toggleMultiFilter(activeFilter, option, $event)"
        />
        <span>{{ option }}</span>
      </label>
    </div>
    <div class="filter-buttons">
      <button (click)="applyFilter(activeFilter)">Apply</button>
      <button (click)="clearFilter(activeFilter)">Clear</button>
    </div>
  </div>

  <ng-template #exportOptionsDialog>
    <div class="dialog-container export-dialog-container">
      <h2 class="dialog-title">Export CDP Corridor Mapping</h2>
      <div class="dialog-content export-dialog-content">
        <p>Select which data you want to download.</p>
      </div>
      <div class="export-dialog-actions">
        <button class="export-dialog-button" [mat-dialog-close]="true" (click)="exportToCSV()">Export Filtered</button>
        <button class="export-dialog-button" [mat-dialog-close]="true" (click)="downloadAllData()">Export All</button>
      </div>
      <div class="dialog-actions export-dialog-footer">
        <button class="cancel-button" [mat-dialog-close]="false">Cancel</button>
      </div>
    </div>
  </ng-template>